import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Course } from '../../models/course.model';
import { TranslateService } from '@ngx-translate/core';
import { Category } from '../../models/category.model';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiV2Service } from '../../services/api-v2.service';
import { Router } from '@angular/router';
import { Organization } from '../../interfaces/organization-info.interface';
import { AuthService } from '../../services/auth.service';
import { country } from 'src/app/mocks/countries.mock';
import { basiclessons } from 'src/app/mocks/basic-lessons.mock';
import { prebasiclessons } from 'src/app/mocks/prebasic-lessons.mock';
import { extracategories } from 'src/app/mocks/extra-categories.mock';
import { Level } from 'src/app/mocks/level-category.mock';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css'],
})

export class FiltersComponent implements OnInit {
  // @Input() courses: Course[];
  courses: Course[] = [];
  filteredCourses: Observable<Course[]>;
  filteredCountries: any[];
  filteredOA: any[]=[];
  filteredDBA: any[]=[];
  filteredUD: any[]=[];
  filteredLesson: any[] = prebasiclessons.concat(basiclessons);
  filteredBasiclessons: any[] = basiclessons;
  filteredPrebasiclessons: any[] = prebasiclessons;
  filteredLevel: any[] = Level;
  filteredextra: any[] = extracategories;
  tagCountry:any;
  tagtag:any;
  tagtag1:any;
  tagtag2:any;
  tagtag3:any;
  tagtag4:any;

  // @Input() categories: Category[];
  categories: Category[];
  filteredCategories: Observable<Category[]>;
  filteredCategories2: any[];

  searchForm: FormGroup;

  constructor(
    private translate: TranslateService,
    private api: ApiV2Service,
    private auth: AuthService,
    private router: Router
  ) {
    this.searchForm = new FormGroup({
      course: new FormControl('', [this.customValidator]),
      category: new FormControl('', [this.customValidator]),
      category1: new FormControl('', [this.customValidator]),
      category2: new FormControl('', [this.customValidator]),
      category3: new FormControl('', [this.customValidator]),
      country: new FormControl(''),
      // search: new FormControl(null)
    });
  }

  ngOnInit(): void {
    console.log(this.router.url)
    /*   if (this.auth.currentMainOrganization) {
      this.getCoursesByOrganizations([this.auth.currentMainOrganization]);
    } else {
      this.getCoursesByOrganizations(this.auth.currentOrganizations);
    } */
    this.getCategories();
  }

  display(){
    if(this.router.url=='/lessons/sima-library' || this.router.url.includes('/lessons/public-activities')){
      return true
    }else{ return false}
  }

  private _filter(value: any, options: any[]): any[] {
    const filterValue =
      value && value.name ? value.name.toLowerCase() : value.toLowerCase();
    return options.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  /* displayCourse(course: Course) {
    return course && course.name ? course.name : '';
  } */
  displayCountries(country: any) {
    return country && country.name ? country.name : '';
  }

  displayCategory(category: Category) {
    return category && category.name ? category.name : '';
  }
  displayLevel(Level: any) {
    return Level && Level.name ? Level.name : '';
  }

  displayLesson(basiclessons: any) {
    return basiclessons && basiclessons.name ? basiclessons.name : '';
  }
  displayLesson2(preBasiclessons: any) {
    return preBasiclessons && preBasiclessons.name ? preBasiclessons.name : '';
  }

  displayExtrastags(extracategories: any) {
    return extracategories && extracategories.name ? extracategories.name : '';
  }

  setSearch() {

    const params = {};
    /*     if (this.searchForm.value && this.searchForm.value.course && this.searchForm.value.course !== '') {
      params['profile_groups'] = this.searchForm.value.course.id; */
    if (
      (this.searchForm.value.category1 &&
        this.searchForm.value.category1 !== '') ||
      (this.searchForm.value.category &&
        this.searchForm.value.category !== '') ||
      (this.searchForm.value.category2 &&
        this.searchForm.value.category2 !== '') ||
      (this.searchForm.value.category3 &&
        this.searchForm.value.category3 !== '')
    ) {
      const params = {
        tags: this.searchForm.value.category.id,
        tags1: this.searchForm.value.category1.id,
        tags2: this.searchForm.value.category2.id,
        tags3: this.searchForm.value.category3.id,
      };
      this.router.navigate(['/lessons/public-activities'], {
        queryParams: params,
      });
      //this.searchForm.value.category = null;
    } else {
      this.router.navigate(['/lessons/activities'], { queryParams: params });
      
    }
    console.log(params)
    this.tagtag=this.searchForm.value.category.name
    this.tagtag1= this.searchForm.value.category1.name
    this.tagtag2= this.searchForm.value.category2.name
    this.tagtag3= this.searchForm.value.category3.name
    //this.tagtag4= this.searchForm.value.category4.name
    this.searchForm.reset({
      category: '',
      category1: '',
      category2: '',
      category3: '',
      country: '',
    });
    //}
  }

  customValidator(control: AbstractControl): { [key: string]: string } | null {
    if (typeof control.value !== 'object' && control.value !== '') {
      return { controlType: 'El tipo de dato no es válido' };
    }
    return null;
  }

  getCategories() {
    this.api
      .getService('GET_CATEGORIES')
      .pipe(
        map((data) => {
          return data['results'];
        })
      )
      .subscribe(
        (categories: Category[]) => {
   
          this.categories = categories;
          // this.currentCategoriesSubject.next(categories);
          this.filteredCategories = this.searchForm
            .get('category')
            .valueChanges.pipe(
              startWith(''),
              map((value) =>
                this._filter(value, this.categories ? this.categories : [])
              )
            );
          //Manejar los filtros OA
          this.filteredOA = this.categories.filter((item) => {
            if (item.name.includes('OA')) {
              return item;
            }
          });
          //Manejar los filtros DBA
          this.filteredDBA = this.categories.filter((item) => {
            if (item.name.includes('DBA')) {
              return item;
            }
          });
          //Manejar los filtros UD
          this.filteredUD = this.categories.filter((item) => {
            if (item.name.includes('UD')) {
              return item;
            }
          });
   

     
          this.filteredCategories2 = this.categories.filter((item) => {
            if (
              item.name.includes('OA') ||
              item.name.includes('DBA') ||
              item.name.includes('UD')
            ) {
              return item;
            }
          });

          this.filteredCountries = country;
          //aca dividir la lista
          localStorage.setItem('categories', JSON.stringify(categories));
        },
        (error) => {
          console.log('Error:', error);
        }
      );
  }

  disabledBotton(): boolean {
    
//country
    const test1 = this.searchForm.get('country').value;
    if (test1.name === 'Chile') {

      this.filteredLevel = Level.filter((item) => {
        if (item.id === '620' || item.id === '621') {
        } else { 
         
          return item;}
      });
   
      this.filteredCategories2 = this.filteredOA;
    } else if (test1.name === 'Colombia') {
      this.filteredLevel = Level.filter((item) => {
        if (item.id === '2' || item.id === '3' || item.id === '4') {
        } 
        else {
       
          return item;}
      });

      this.filteredCategories2 = this.filteredDBA.concat(this.filteredUD);
    } else {
  
      this.filteredLevel = Level;

      this.filteredCategories2 = this.filteredOA.concat(
        this.filteredDBA.concat(this.filteredUD)
      );
      this.filteredLesson = prebasiclessons.concat(basiclessons);
    }
    //level
      const test = this.searchForm.get('category').value;
      if (
        test.id === '620' ||
        test.id === '621' ||
        test.id === '2' ||
        test.id === '3' ||
        test.id === '4'
      ) {

        this.filteredLesson = prebasiclessons;
      } else if (
        
          test.id === '5' ||
          test.id === '6' ||
          test.id === '7' ||
          test.id === '8' ||
          test.id === '9' || 
          test.id === '10' 
        
      ) {

        this.filteredLesson = basiclessons;
      } else {
 
        this.filteredLesson = prebasiclessons.concat(basiclessons);
      }
    
    

   //--------------------------------------------------------------
 
    if (
      this.searchForm.get('category').value !== '' ||
      this.searchForm.get('category1').value !== '' ||
      this.searchForm.get('category2').value !== '' ||
      this.searchForm.get('category3').value !== ''
    ) {
      return false;
    } else return true;
  }
}
